import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { VentaService } from '../../../services/venta.service';
import { Venta } from '../../../models/venta';
import { ClienteModalComponent } from '../../modals/cliente-modal/cliente-modal.component';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { BsModalService } from 'ngx-bootstrap/modal';
import { ClienteService } from '../../../services/cliente.service';
import { Cliente } from '../../../models/cliente';
import { Retencion } from '../../../models/retencion';
import { PlanAcumulativoService } from '../../../services/plan-acumulativo.service';
import { PlanAcumulativo } from '../../../models/plan-acumulativo';
import { ParametroService } from '../../../services/parametro.service';
import { UtilsService } from '../../../services/utils.service';

@Component({
	selector: 'cobro-list',
	templateUrl: './cobro-list.component.html',
	styleUrls: ['./cobro-list.component.css'],
	providers: [
		VentaService,
		ClienteService,
		PlanAcumulativoService,
		ParametroService
	]
})
export class CobroListComponent implements OnInit, OnDestroy {
	public ventas: Array<Venta>;
	public planes: Array<PlanAcumulativo>;
	public bsModalRef: BsModalRef;
	public cliente: Cliente;
	public loading = false;
	public numero_decimales: number;
    public format_decimal: String;

	constructor(
		public ventaService: VentaService,
		private NavRoute: Router,
		private modalService: BsModalService,
		public clienteService: ClienteService,
		public planAcumulativoService: PlanAcumulativoService,
		private parametroService: ParametroService,
		public utils: UtilsService,
		//private storage: AsyncLocalStorage,
	) {		
		this.ventas = [];
		this.planes = [];
		this.cliente = new Cliente();
		this.numero_decimales = 2;
        this.format_decimal = "0,0.00";
	}

	ngOnInit() {
		this.loading = true;
		this.getParamNumeroDecimales().then(
			res => this.loading = false,
			err => this.loading = false,
		);
	}

	ngOnDestroy(){
		//
	}

	onSearchCliente(event) {
		if( event.keyCode === 13 ){
			if( this.cliente.dni.toString().trim().length == 0 ){
				this.cliente = new Cliente();
				this.ventas = [];
				return;
			}else{
				this.loading = true;
				this.clienteService.getByDni(this.cliente.dni).subscribe(
					res => {
						if (res.length > 0) {
							this.cliente = res[0];

							let p1 = this.getVentasCredito(this.cliente.id);
							let p2 = this.getPlanAcumulativo(this.cliente.id);

							Promise.all([p1,p2]).then(
								res => this.loading = false,
								err => this.loading = false,
							);
						}else{
							this.loading = false;
							this.cliente = new Cliente();
							this.ventas = [];
							this.openDialogCliente();
						}
					},
					err => {
						this.loading = false;
						this.ventas = [];
						this.openDialogCliente();
					}
				);
			}
		}
    }

	openDialogCliente() {
		const initialState = {cobros_pendientes: true};
		this.bsModalRef = this.modalService.show(ClienteModalComponent, Object.assign({}, {class: 'modal-xlg', initialState}));

		this.bsModalRef.content.sendCliente.take(1).subscribe(cliente => {
			this.cliente = cliente;

			this.loading = true;

			let p1 = this.getVentasCredito(this.cliente.id);
			let p2 = this.getPlanAcumulativo(this.cliente.id);

			Promise.all([p1,p2]).then(
				res => this.loading = false,
				err => this.loading = false,
			);
		});
	}

	getVentasCredito(cliente_id){
		return new Promise((resolve, reject) => {
			this.ventaService.getAll("?tipo=CR&embed=tipocomprobante,retencion&estado_pago=P&cliente_id="+cliente_id+"&sort=-fecha_emision,-secuencial&status=A").subscribe(
				res => {
					if( res.data.length ){
						this.ventas = res.data;
						this.ventas.forEach((venta: Venta) => {
							if( !venta.retencion ){
								venta.retencion = new Retencion();
							}
						});
					}else{
						this.ventas = [];
					}
					resolve();
				},
				err => {
					this.ventas = [];
					reject(err);
				}
			);
		});
	}

	getPlanAcumulativo(cliente_id){
		return new Promise((resolve, reject) => {
			this.planAcumulativoService.getAll("?estado_pago=P&cliente_id=" + cliente_id + "&embed=tipocomprobante,cliente&sort=-secuencial").subscribe(
				res => {
					this.planes = res.data;
					resolve();
				},
				err => {
					this.planes = [];
					reject(err);
				}
			);
		});
	}

	onShow(id){
		this.NavRoute.navigate(['/ventas/ventas-show/' + id]);
	}

	onPay(id, tipo){
		this.NavRoute.navigate(['/cobro/cobro/' + tipo + '/' + id]);
	}
	
	numeroFactura(venta){
        return venta.serie + "-" + venta.punto_emision + "-" + venta.secuencial;
	}

	calcSaldo(venta){
        let saldo = venta.total - venta.abonado;

        if( venta.retencion ){
            saldo = saldo - venta.retencion.total;
        }
		//return saldo = Math.round(saldo * 100) / 100;
		return saldo = this.utils.redondear(saldo, this.numero_decimales);
	}
	
	getParamNumeroDecimales(){
        return new Promise((resolve, reject) => {
            let numero_decimales = 19;
            this.parametroService.getById(numero_decimales).subscribe(
                res => {
                    this.numero_decimales = res.valor;

                    let digitos = "";
                    for(let i = 0; i < this.numero_decimales; i++) digitos += "0";
                    this.format_decimal = "0,0." + digitos
                    resolve();
                },
                err => {
                    this.numero_decimales = 2;
                    this.format_decimal = "0,0.00"
                    reject(err);
                }
            );
        });
	}
	
	get formatDecimal(){
        return this.format_decimal;
    }
}



// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/components/cobros/cobro-list/cobro-list.component.ts